class API{
    static BASE_URL: string = '/api/'; //(process.env.REACT_APP_SERVER_BASE_URL || "http://192.168.0.102:8000/");

    static LOGIN: string = API.BASE_URL+"auth/log-in";
    static LOGOUT: string = API.BASE_URL+"auth/log-out";
    static VERIFY_TOKEN: string = API.BASE_URL+"auth/verify-token";

    static ADMIN_USERS: string = API.BASE_URL+"admin/users";

    static ADMIN_KW_DIV: string = API.BASE_URL+"admin/divisions";
    static ADMIN_KW_DIV_FULL: string = API.BASE_URL+"admin/divisions-full";
    static ADMIN_KW_IND: string = API.BASE_URL+"admin/indicators/";
    static ADMIN_KW_GR: string = API.BASE_URL+"admin/groups/";
    static ADMIN_KW_EXPORT: string = API.BASE_URL+"admin/export-keywords";
    static ADMIN_KW_EXPORT_R: string = API.BASE_URL+"admin/export-keywords-readable";
    static ADMIN_KW_IMPORT: string = API.BASE_URL+"admin/import-keywords";

    static CSI_UPLOAD_AI: string = API.BASE_URL+"csi/upload-ai";
    static CSI_UPLOAD_KW: string = API.BASE_URL+"csi/upload-kw/";
    static CSI_STATUS: string = API.BASE_URL+"csi/status/";
    static CSI_DOWNLOAD: string = API.BASE_URL+"csi/download/";
    static CSI_HISTORY: string = API.BASE_URL+"csi/history/";
}

export default API;